<template>
  <q-card flat :style="$q.screen.lt.md?'':'width: 500px; max-width: 80vw;'">
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        <span>سفارش</span>
        <span> <q-badge align="top" color="red" text-color="white" class="q-ml-xs">{{ saleNum }}</q-badge></span>
        <template v-slot:action>
          <q-btn icon="close" flat round dense v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding text-center"
                    v-if="$store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))">
      <q-chip color="indigo" text-color="white" square v-for="(item,index) in groupedList" :key="index"
              :label="item.Group_Name">
        <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                 :label="`${item.sum.toLocaleString()} ریال`"/>
        <q-badge v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))" class="q-ml-sm"
                 :color="item.sum>0?'green':'red'" text-color="white"
                 :label="`سود: ${parseInt(item.profit.toFixed(0)).toLocaleString()} ریال`"/>
        <q-tooltip v-if="$store.state.roles.some(v=>['admin','see_profit'].includes(v))"
                   content-class="bg-transparent">
          <q-chip text-color="white" color="indigo" square label="فروش">
            <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                     :label="`${item.sum.toLocaleString()} ریال`"/>
          </q-chip>
          <q-space/>
          <q-chip text-color="white" color="indigo" square label="خرید">
            <q-badge class="q-ml-sm" :color="item.sum>0?'green':'red'" text-color="white"
                     :label="`${(item.sum - item.profit).toLocaleString()} ریال`"/>
          </q-chip>

        </q-tooltip>
      </q-chip>
    </q-card-section>
    <q-card-section>
      <q-table
          :data="lodash.sortBy(OrderDetailsList, ['Group_Name', 'Goods_Name'])"
          row-key="Sale_Num"
          wrap-cells
          hide-header
          flat
          :pagination.sync="pagination">
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class">
            <q-td>
              <q-card flat>
                <q-card-section class="no-padding">
                  <q-chip clickable square
                          @click="showProductDetailsDialog(props.row)"
                          v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                          :label="props.row.Goods_Code"/>
                </q-card-section>
                <q-card-section class="no-padding">
                  {{ props.row.Goods_Name }}
                  <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                    {{ props.row.SaleG_Count }}
                  </q-badge>
                  <q-badge color="brown" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                    {{ props.row.Unit_Name }}
                  </q-badge>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-chip :size="$q.screen.lt.md?'md':'md'" color="blue"
                          text-color="white" square flat
                          label="قیمت واحد" v-if="props.row.Goods_Code!=='109991'">
                    <q-badge color="red" class="q-ml-xs">{{ props.row.SaleG_PricePure | toLoalString }} ریال
                    </q-badge>
                  </q-chip>
                  <q-chip v-if="props.row.SaleG_TotalAll>0" :size="$q.screen.lt.md?'md':'md'" square color="indigo"
                          text-color="white" flat
                          label="قیمت کل">
                    <q-badge color="red-14" class="q-ml-xs">{{ props.row.SaleG_After_Off | toLoalString }}
                      ریال
                    </q-badge>
                  </q-chip>
                  <q-chip v-if="props.row.SaleG_Off && props.row.SaleG_Off>0" square color="indigo"
                          text-color="white" icon="trending_down" label="تخفیف">
                    <q-badge color="red" text-color="white" :label="`${props.row.SaleG_Off.toLocaleString()}`"/>
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding">
                  <q-chip :size="$q.screen.lt.md?'md':'md'" color="blue"
                          text-color="white" square flat
                          label="مبلغ واحد خرید روز"
                          v-if="props.row.Goods_Code!=='109991' && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && props.row.Goods_Code!=='109991'">
                    <q-badge color="red" class="q-ml-xs">{{ props.row.BuyDay_Price | toLoalString }} ریال
                    </q-badge>
                  </q-chip>
                  <q-chip
                      v-if="props.row.SaleG_TotalAll>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && props.row.Goods_Code!=='109991'"
                      :size="$q.screen.lt.md?'md':'md'" square color="indigo"
                      text-color="white" flat
                      label="مبلغ کل خرید روز">
                    <q-badge color="red-14" class="q-ml-xs">
                      {{ props.row.SaleG_Count * props.row.BuyDay_Price | toLoalString }}
                      ریال
                    </q-badge>
                  </q-chip>
                  <q-chip
                      v-if="props.row.SaleG_TotalAll>0 && $store.state.roles.some(v=>['admin','can_see_by_price'].includes(v))  && props.row.Goods_Code!=='109991'"
                      square color="indigo"
                      text-color="white" icon="trending_up" label="سود فروش">
                    <q-badge
                        text-color="white"
                        :color="(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2) > 0 ?'green':'red'"
                        :label="`${ parseInt((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price)).toFixed(0)).toLocaleString()}`"/>
                  </q-chip>
                  <q-chip
                      v-if="props.row.SaleG_TotalAll>0 && $store.state.roles.some(v=>['admin','see_profit'].includes(v))  && props.row.Goods_Code!=='109991'"
                      square color="indigo"
                      text-color="white" icon="trending_up" label="درصد سود فروش">
                    <q-badge
                        :color="(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2) > 0 ?'green':'red'"
                        text-color="white"
                        :label="`${(((props.row.SaleG_TotalAll - (props.row.SaleG_Count *  props.row.BuyDay_Price))/props.row.SaleG_TotalAll)*100).toFixed(2)} %`"/>
                  </q-chip>
                </q-card-section>
              </q-card>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>

    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>

  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "OrderDetailsMobile",
  components: {ProductDetail},
  props: ['saleNum', 'store_id', 'hava_num'],
  data() {
    return {
      selectedProductDetails:[],
      showProductDetails:false,
      OrderDetailsList: [],
      groupedList: [],
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      getDetails: 'Orders/getOrderDetail',
      getOrderDetailByStoreID: 'Orders/getOrderDetailByStoreID',
      getProductInfo: 'Products/getProductInfo'
    }),
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
    getOrderDetailsList() {
      if (this.store_id !== null) {
        this.getOrderDetailByStoreID({
          sale_num: this.saleNum,
          hava_num: this.hava_num,
          store_id: this.store_id
        }).then((res) => {
          this.OrderDetailsList = res.data;
          this.groupedList = this.lodash(this.OrderDetailsList).filter(item => item.Goods_Group !== 86).groupBy('Group_Name')
              .map(function (items, Group_Name) {
                return {
                  Group_Name: Group_Name,
                  sum: items.map(item => item.SaleG_TotalAll).reduce((accumulator, curr) => accumulator + curr),
                  profit: items.map(item => (item.SaleG_TotalAll - (item.SaleG_Count * item.BuyDay_Price))).reduce((accumulator, curr) => accumulator + curr)
                };
              }).value();
        });
      } else {
        this.getDetails(this.saleNum).then((res) => {
          this.OrderDetailsList = res.data;
          this.groupedList = this.lodash(this.OrderDetailsList).filter(item => item.Goods_Group !== 86).groupBy('Group_Name')
              .map(function (items, Group_Name) {
                return {
                  Group_Name: Group_Name,
                  sum: items.map(item => item.SaleG_TotalAll).reduce((accumulator, curr) => accumulator + curr),
                  profit: items.map(item => (item.SaleG_TotalAll - (item.SaleG_Count * item.BuyDay_Price))).reduce((accumulator, curr) => accumulator + curr)
                };
              }).value();
        });
      }
    }
  },
  created() {
    this.getOrderDetailsList();
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>